export class ProgramAnswer {
  public name: string;
  public value?: string | string[] | boolean | number;
  public answerOrder?: number;
  public chainId?: string;
  public projectId?: string;
  public responderId?: number;
  public metadata?: { signature: string };
}
